import React from "react";
import EntityListPage, { StatusBadge } from "@/components/EntityListPage";

const FIELDS = [
    { key: "name", label: "Supplier name", required: true },
    { key: "code", label: "Supplier code" },
    { key: "contact_person", label: "Contact person" },
    { key: "phone", label: "Phone" },
    { key: "email", label: "Email" },
    { key: "gst_number", label: "GSTIN" },
    { key: "address_line1", label: "Address" },
    { key: "city", label: "City" },
    { key: "state", label: "State" },
    { key: "pincode", label: "PIN code" },
    { key: "payment_terms_days", label: "Payment terms (days)", type: "number", default: 0 },
    { key: "lead_time_days", label: "Lead time (days)", type: "number", default: 0 },
    { key: "tags", label: "Tags", type: "tags", full: true },
    { key: "notes", label: "Notes", type: "textarea", full: true },
    { key: "is_active", label: "Active", type: "boolean", default: true },
];

const COLUMNS = [
    {
        key: "name",
        label: "Supplier",
        render: (r) => (
            <div>
                <div className="text-sm font-medium text-zinc-900">{r.name}</div>
                {r.contact_person && <div className="text-xs text-zinc-500">{r.contact_person}</div>}
            </div>
        ),
    },
    { key: "phone", label: "Phone", render: (r) => <span className="text-xs text-zinc-700">{r.phone || "—"}</span> },
    { key: "city", label: "City", render: (r) => <span className="text-xs text-zinc-700">{r.city || "—"}</span> },
    {
        key: "lead_time_days",
        label: "Lead time",
        align: "right",
        render: (r) => <span className="font-mono text-xs">{r.lead_time_days || 0}d</span>,
    },
    {
        key: "payment_terms_days",
        label: "Terms",
        align: "right",
        render: (r) => <span className="font-mono text-xs">Net {r.payment_terms_days || 0}</span>,
    },
    { key: "is_active", label: "Status", render: (r) => <StatusBadge active={r.is_active} /> },
];

export default function SupplierBrain() {
    return (
        <EntityListPage
            testId="page-supplier-brain"
            title="Supplier Brain"
            description="Reliability, lead times, and negotiation intelligence for every vendor."
            resourcePath="/suppliers"
            fields={FIELDS}
            columns={COLUMNS}
            addLabel="Add supplier"
            emptyLabel="No suppliers yet."
        />
    );
}
